<template>
<div>
  <div class="columns">
    <div class="column">
      <p>
        Pipeline Input Type: {{ scraperType.pipeline_input }}
        <icon 
          v-tooltip="
            pipelineInputType === scraperType.pipeline_input 
            ? 'The previous scrapers return type matches the input type for this scraper type. This is good'
            : 'The return type from the previous scraper does not match the input type for this scraper type.'
          "
          :class="{
            'has-text-success': pipelineInputType === scraperType.pipeline_input,
            'has-text-danger': pipelineInputType !== scraperType.pipeline_input,
          }"
          :icon="pipelineInputType === scraperType.pipeline_input ? 'check' : 'times'"/>
      </p>
    </div>
    <div class="column">
      <p>
        Pipeline Output Type: {{ scraperType.pipeline_ouput }}
      </p>
    </div>
    <div class="column">
      <p>Builder Input Type: {{ scraperType.builder_input || 'Does not take builder input' }}</p>
    </div>
  </div>  
</div>  
</template>
<script>
export default {
  props: {
    pipelineInputType: String,
    scraperType: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>